// Whitelabels that are Swoop regions — they share Swoop's sidebar branding
// (deep-teal #012734 background + the "S" monogram when collapsed). tenantId values,
// normalised to lowercase alphanumerics so formatting differences don't matter.
const SWOOP_BRANDED_TENANTS = ['swoop', 'southafrica', 'ireland', 'us']

export const isSwoopBrandedTenant = tenantId => {
  const id = (tenantId || '').toLowerCase().replace(/[^a-z0-9]/g, '')
  return SWOOP_BRANDED_TENANTS.includes(id)
}

export const mapCountryCodeToTenant = countryCode => {
  switch (countryCode) {
    case 'GB':
    case 'IE':
    case 'ZA':
      return 'uk'
    case 'AU':
      return 'aus'
    case 'CA':
      return 'canada'
    case 'US':
      return 'canada'
  }

  return null
}
